import { Component } from '@angular/core';

@Component({
  selector: 'app-wo-technology',
  templateUrl: './wo-technology.component.html',
  styleUrls: ['./wo-technology.component.css']
})
export class WoTechnologyComponent {

}
